import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { GoogleAuthProvider, signInWithPopup, getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { useEffect } from "react";
import { apiRequest } from "../apiService/allApi";
const axios = require("axios");

const firebaseConfig = {
  apiKey: "AIzaSyCXXt25pcXGlodmXRLKg2QNNJptKrzGBJs",
  authDomain: "staradda-88c65.firebaseapp.com",
  projectId: "staradda-88c65",
  storageBucket: "staradda-88c65.appspot.com",
  messagingSenderId: "1051681849557",
  appId: "1:1051681849557:web:105e8af8a6458a238ce25c",
  measurementId: "G-G82LJL25BC",
};
// BASE URL
 
const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
const nodeMode = process.env.NODE_ENV;
if (nodeMode === "development") {

  var baseUrl = beckendLocalApiUrl;
} else {
  baseUrl = beckendLiveApiUrl;
}
// +++++++++++++++++++++++++++++ 
const access_token = localStorage.getItem("token");
const fcm = localStorage.getItem("fcm");
export const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

const db = getFirestore(app);

export const getTokens = async (setTokenFound) => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BIVwdUaV6wHX0uLdw8SwDLnYEdXQUVXW9LduRQmn8DbcR7sDwCmd-opV6GGHkM2etKXvY5wi4tAlcnFMHOp8evs",
    });

    if (currentToken) {
      if (access_token && fcm !== currentToken) {
        const headers = {
          Authorization: `Bearer ${access_token}`,
        };
        try {
          // const res = await axios.get(
          //   baseUrl+`updateToken?firebaseToken=${currentToken}`,
          //   { headers }
          // );
          const res = await apiRequest(`updateToken?firebaseToken=${currentToken}`,"GET",null,headers)

          console.log(res);
          localStorage.setItem("fcm", currentToken);
        } catch (e) {
          console.log(e);
        }
      }
      setTokenFound({ status: true, token: currentToken });
    } else {
      console.log(
        "No registration token available. Request permission to generate one."
      );
      setTokenFound(false);
    }
  } catch (err) {
    // console.log(err);
  }
};

getTokens();
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
      console.log(payload);
    });
  });

// async function loginWithGoogle() {
//     try {
//         const provider = new GoogleAuthProvider();
//         const auth = getAuth();

//         const { user } = await signInWithPopup(auth, provider);

//         return { uid: user.uid, displayName: user.displayName };
//     } catch (error) {
//         if (error.code !== 'auth/cancelled-popup-request') {
//             console.error(error);
//         }

//         return null;
//     }
// }
// const provider=JSON.parse(localStorage.getItem('provider'));
//console.log(provider?.provider_data?.id)
// async function sendMessage(roomId, user, text) {
//     try {
//         await addDoc(collection(db, 'chatRoom', roomId, 'chats'), {
//             //   uid: user.uid,
//             //   displayName: user.displayName,
//             //   text: text.trim(),
//             //   timestamp: serverTimestamp(),
//             uid: user?.data?.id || null,
//             displayName: user?.data?.display_name || null,
//             user_type:user?.data?.user_type,
//             reciver_id:provider?.provider_data?.id,
//             text: text.trim(),
//             timestamp: serverTimestamp(),
//         });

//     } catch (error) {
//         console.error(error);
//     }
// }

// function getMessages(roomId, callback) {
//     return onSnapshot(
//         query(
//             collection(db, 'chatRoom', roomId, 'chats'),
//             orderBy('timestamp', 'asc')
//         ),
//         (querySnapshot) => {
//             const messages = querySnapshot.docs.map((doc) => ({
//                 id: doc.id,
//                 ...doc.data(),
//             }));
//             console.log(messages)
//             callback(messages);
//         }
//     );
// }


